// General
const ERROR_401 = 401;
const ERROR_403 = 403;
const ERROR_CODE_BAD_REQUEST = 400;
const ERROR_CODE_DUPLICATE = 406;
const ERROR_CODE_CONFLICT = 409;
const ERROR_CODE_NOT_FOUND = 404;
const ERROR_CODE_NOT_ACCEPTABLE = 406;
const ERROR_CODE_HAS_RELATIONSHIP = 406;
const ERROR_CODE_TRANSCRIPTION_IN_PROGRESS = 406;
const ERROR_CODE_HAS_TRANSCRIPTION_IN_PROGRESS = 409;
const ERROR_CODE_FILE_SIZE_EXCEEDED = 413;
const ERROR_CODE_CLIENT_UNIT_DISABLED = 409;
const ERROR_CODE_PATIENT_DISABLED = 409;
const ERROR_CODE_FIRST_ACCESS_CONFLICT = 409;
const ERROR_CODE_FIRST_ACCESS_INVALID_TOKEN = 406;
const ERROR_CODE_CFM_FAIL = 503;
const ERROR_CODE_CFM_CRM_NOT_FOUND = 404;
const ERROR_CODE_CNPJ_INVALID = 409;
const ERROR_CODE_CNPJ_FAIL = 503;
const ERROR_CODE_CNPJ_NOT_FOUND = 404;
const ERROR_CODE_CFM_CRM_INVALID = 409;
const ERROR_CODE_MATERIALS_DUPLICATE = 406;
const ERROR_CODE_MATERIALS_DELETE = 409;
const ERROR_CODE_LOGIN_INVALID = 401;
const ERROR_CODE_UNAUTHORIZED_INVALID = 403;
const ERROR_CODE_PRODUCTS_DUPLICATE = 406;
const ERROR_CODE_PRODUCTS_CONFLICT = 409;
const ERROR_CODE_BUSINESS_UNIT_DUPLICATE = 406;
const ERROR_CODE_GROUPS_DELETE = 409;
const ERROR_CODE_SUBGROUPS_DELETE = 409;
const ERROR_CODE_EXPRESSIONS_DELETE = 409;
const ERROR_CODE_PRESCRIPTION_TEMPLATE_DUPLICATE = 409;
const ERROR_CODE_TEAM_DUPLICATE_CODE = 409;

export {
  ERROR_401,
  ERROR_403,
  ERROR_CODE_DUPLICATE,
  ERROR_CODE_CONFLICT,
  ERROR_CODE_NOT_FOUND,
  ERROR_CODE_NOT_ACCEPTABLE,
  ERROR_CODE_HAS_RELATIONSHIP,
  ERROR_CODE_TRANSCRIPTION_IN_PROGRESS,
  ERROR_CODE_HAS_TRANSCRIPTION_IN_PROGRESS,
  ERROR_CODE_FILE_SIZE_EXCEEDED,
  ERROR_CODE_BAD_REQUEST,
  ERROR_CODE_CLIENT_UNIT_DISABLED,
  ERROR_CODE_PATIENT_DISABLED,
  ERROR_CODE_FIRST_ACCESS_CONFLICT,
  ERROR_CODE_FIRST_ACCESS_INVALID_TOKEN,
  ERROR_CODE_CFM_FAIL,
  ERROR_CODE_CFM_CRM_NOT_FOUND,
  ERROR_CODE_CFM_CRM_INVALID,
  ERROR_CODE_CNPJ_FAIL,
  ERROR_CODE_CNPJ_NOT_FOUND,
  ERROR_CODE_CNPJ_INVALID,
  ERROR_CODE_MATERIALS_DUPLICATE,
  ERROR_CODE_MATERIALS_DELETE,
  ERROR_CODE_LOGIN_INVALID,
  ERROR_CODE_UNAUTHORIZED_INVALID,
  ERROR_CODE_PRODUCTS_DUPLICATE,
  ERROR_CODE_PRODUCTS_CONFLICT,
  ERROR_CODE_BUSINESS_UNIT_DUPLICATE,
  ERROR_CODE_GROUPS_DELETE,
  ERROR_CODE_SUBGROUPS_DELETE,
  ERROR_CODE_EXPRESSIONS_DELETE,
  ERROR_CODE_PRESCRIPTION_TEMPLATE_DUPLICATE,
  ERROR_CODE_TEAM_DUPLICATE_CODE,
};
